import gql from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

const TestDrivesQuery = {
  getAllReceivedTestDriveProducts: gql`
    query getAllReceivedTestDriveProducts {
      getAllReceivedTestDriveProducts {
        ...CatalogItemCardFragment
        isCommented
      }
    }
    ${CatalogItemCardFragment}
  `,
  getTestDrives: gql`
    query getTestDrives($page: Int, $setLimit: Int, $setSort: String) {
      allTestDriveTesters
      findTestDriveAll(page: $page, setLimit: $setLimit, setSort: $setSort) {
        totalCount
        testDrivesCount
        testDriveItems {
          id
          min_sum
          catalogItems {
            id
          }
          people_status_id
          title
          amount
          completed
          peopleCount
          date
          produtImages
          fileItem {
            tempFullFilePath
          }
        }
      }
    }
  `,
  getTestDriveById: gql`
    query getTestDriveById($cartToken: String, $id: Int!) {
      getTestDriveById(cartToken: $cartToken, id: $id) {
        id
        text
        produtImages
        ordersItems {
          orderItem {
            peopleItem {
              fio
              attachmentsItem {
                tempFullFilePath
              }
            }
          }
        }

        file_id
        title
        people_status_id # 3 - Зорлото, 2 - Серебро, null - для всех
        completed # if (completed === "Y" && amount < 1) => Тест драйв завершен
        amount # отстаток
        min_sum # мин сумма заказа
        date # дата завершения
        fileItem {
          cacheItem {
            filePath
          }
        }
        catalogItems {
          id
          hit
          price_retail
          subtitle
          title
          rating_comments
          comments_number
          active
          available
          sales_number
          delivery {
            date
            is_nearest
          }

          oldPriceField
          discounPriceField
          currentPriceField

          oldPriceField2
          discounPriceField2
          currentPriceField2

          symbolPriceField
          fileItem {
            cacheItem {
              filePath
            }
          }
        }
        peopleCount # кол-во участников
        commentsCount
        comments {
          id
          item_id
          date
          text

          rating

          votes_no
          votes_yes
          _voted
          item_id

          answer
          answer_user_id
          answer_date
          peopleItem {
            id
            fio
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          answerUserItem {
            id
            secondname
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
        }
        uncommentedProducts {
          id
          hit
          price_retail
          subtitle
          title
          rating_comments
          comments_number
          active
          oldPriceField
          discounPriceField
          currentPriceField
          symbolPriceField
          fileItem {
            cacheItem {
              filePath
            }
          }
        }
      }
    }
  `,
  getTestDrivesCount: gql`
    query getTestDrivesCount {
      getTestDrivesCount
    }
  `
};

export default TestDrivesQuery;
